import React, { useEffect, useState } from 'react';
import style from './App/App.module.scss';
import classnames from 'classnames';
import { useGetPlans } from '../hooks/useGetPlans.hook';
import { useAuth } from '../context/Auth.context';
import { IPlan } from '../model';
import { AppContext } from '../context/AppContext';
import MainContent from './MainContent';
import RenewNowModal from './RenewNowModal/RenewNowModal';

function SportPlans({sport}: { sport: string }) {
  const {subscriptions, loading, baseCheckoutPath} = useAuth();
  const yearly = true;
  const [renewPopup, showRenewPopup] = useState<null | { plan: IPlan }>(null);
  const [preparedPlans, setPreparedPlans] = useState<IPlan[]>([]);

  let {
    // processedPlans,
    plans: filteredPlans,
    totalPrice,
    currentSubscriptions,
    onePaymentItems
    // precessedOnePaymentItems
  } = useGetPlans(subscriptions || [], sport, true);
  console.log('plans: ', filteredPlans);

  useEffect(() => {
    setPreparedPlans(filteredPlans)
  }, [filteredPlans]);

  const toggleAdditionalPlan = (id: string, state?: boolean) => {
    setPreparedPlans(preparedPlans.map(plan => plan.plan_id === id ? ({
      ...plan,
      isAdditional: state ?? !plan.isAdditional
    }) : plan))
  };

  return (
    <AppContext.Provider value={{
      yearly,
      currentSubscriptions,
      totalPrice,
      sport,
      baseCheckoutPath,
      toggleAdditionalPlan,
      showRenewPopup,
    }}>
      <div className={classnames(style.container)} style={{paddingBottom: 80, overflow: 'hidden'}}>
        <div className={classnames(style.loader_wrapper, {[style.show]: loading})}>
          <div className={classnames(style.loader)} style={{margin: '0 auto'}}>
            <span/><span/><span/><span/><span/>
          </div>
        </div>
        {!loading ? <MainContent plans={preparedPlans} onePaymentItems={onePaymentItems} sport={sport}/> : ''}
      </div>
      {renewPopup ? <RenewNowModal plan={renewPopup.plan} close={() => showRenewPopup(null)}/> : ''}
    </AppContext.Provider>
  );
}

export default SportPlans;
